import React from 'react';
import Button from '../button/button';
import {H3, P} from '../typography/typography';
import './product-additional-info.scss';

const ProductAdditionalInfo = ({product, hasPrints, printPrice, pdp = false}: propTypes) => {
  return (
    <div className="product-more">
      {product.is_in_stock && product.holiday_user_message && (
        <div className="alert alert-warning" role="alert">
          {product.holiday_user_message}
        </div>
      )}

      {!product.is_in_stock && (
        <Button disabled wide>
          {hasPrints ? 'Original sold' : 'Sold'}
        </Button>
      )}

      {((!product.is_in_stock && !hasPrints && product.artist_accepts_commissions) ||
        (!product.is_in_stock && pdp && product.artist_accepts_commissions)) && (
        <>
          <H3 style="art">Do you like this artwork?</H3>

          <P style="p1">
            This artwork has sold, but the artist is accepting commission requests. Commissioning an
            artwork is easy and you get a perfectly personalised piece.
          </P>
        </>
      )}

      {!product.is_in_stock && hasPrints && !pdp && (
        <>
          <H3 style="art">Limited edition prints available</H3>

          <P style="p1">Fine art prints of this artwork are available from {printPrice}</P>
        </>
      )}
    </div>
  );
};

interface propTypes {
  product: any;
  hasPrints: boolean;
  printPrice?: any;
  pdp?: boolean;
}

export default ProductAdditionalInfo;
